import { render } from "./BorderWrapper.vue?vue&type=template&id=4ae8da5b"
import script from "./BorderWrapper.vue?vue&type=script&lang=js"
export * from "./BorderWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__